/**
 * One date convention for the whole app.
 *
 * The list pages used to render `M/d/yy, h:mm a` while the detail page used `dd-MM-yyyy`, so the
 * same timestamp read as two different dates depending on where you saw it -- and for any day
 * before the 13th neither one told you which half was the month.
 *
 * Seconds are kept: sync debugging turns on the order of events within a minute.
 */
export const DATE_TIME_FORMAT = 'dd-MM-yyyy HH:mm:ss';

export const DATE_FORMAT = 'dd-MM-yyyy';
